import { toDisplayString as _toDisplayString, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-393c9a58")

_pushScopeId("data-v-393c9a58")
const _hoisted_1 = { class: "container p-4" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-check fs-16 ml-2" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-delete-cross fs-14 ml-2" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon-f icon-check fs-16 ml-2" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("h4", {
      class: { 'text-center': _ctx.align == 'row', 'mb-5': _ctx.align == 'row' }
    }, _toDisplayString(_ctx.$t('order.hasCustomerArrived')), 3),
    _createVNode("div", {
      class: { 'button-container-column': _ctx.align == 'column', 'button-container-row': _ctx.align == 'row' }
    }, [
      _createVNode("button", {
        class: ["arrival-btn", { mobile: _ctx.align == 'row' }],
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.saveArrived && _ctx.saveArrived(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('order.arrivalConfirmation.arrived')) + " ", 1),
        _hoisted_2
      ], 2),
      _createVNode("button", {
        class: ["arrival-btn", { mobile: _ctx.align == 'row' }],
        style: {"background-color":"#fd695a"},
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveNotArrived && _ctx.saveNotArrived(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('order.arrivalConfirmation.notArrived')) + " ", 1),
        _hoisted_3
      ], 2),
      _createVNode("button", {
        class: ["arrival-btn", { mobile: _ctx.align == 'row' }],
        style: {"background-color":"#f6ae28"},
        onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.saveArrivedPartially && _ctx.saveArrivedPartially(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.$t('order.arrivalConfirmation.arrivedPartially')) + " ", 1),
        _hoisted_4
      ], 2)
    ], 2)
  ]))
})